import { RefObject } from 'react';
import { getFocusableElements, FOCUSABLE_ELEMENTS_SELECTOR } from './get-focusable-elements';
import { UsePopoverTimeoutsReturn } from './use-popover-timeouts';

export type UseOpenAutoFocusParams = {
  contentRef: RefObject<HTMLDivElement | null>;
  timeouts: UsePopoverTimeoutsReturn;
  focusableElementsSelector?: string;
};

export type UseOpenAutoFocusReturn = {
  handleAutoFocus: (keyDirection: 'ArrowUp' | 'ArrowDown') => void;
};

/**
 * Handle focus management when opening popover with arrow keys.
 * - ArrowUp: focuses the last focusable element
 * - ArrowDown: focuses the first focusable element
 */
export function useOpenAutoFocus({
  contentRef,
  timeouts,
  focusableElementsSelector = FOCUSABLE_ELEMENTS_SELECTOR,
}: UseOpenAutoFocusParams): UseOpenAutoFocusReturn {
  const handleAutoFocus = (keyDirection: 'ArrowUp' | 'ArrowDown') => {
    timeouts.scheduleAutoFocus(() => {
      const contentEl = contentRef.current;
      if (!contentEl) return;

      const { firstElement, lastElement } = getFocusableElements(contentEl, focusableElementsSelector);

      if (keyDirection === 'ArrowUp') {
        if (lastElement) {
          lastElement.focus();
        }
      } else if (keyDirection === 'ArrowDown') {
        if (firstElement) {
          firstElement.focus();
        }
      }
    });
  };

  return {
    handleAutoFocus,
  };
}
